"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_3 = require("@iconify/react");
var react_redux_1 = require("react-redux");
var customers_1 = require("../api/customers");
var label_1 = require("../controls/label");
var main_1 = require("../reducers/slices/main");
var addressSearch_1 = require("./addressSearch");
var AddressComponent = function (_a) {
    var customerId = _a.customerId, _b = _a.isReadOnly, isReadOnly = _b === void 0 ? false : _b;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, react_2.useState)(false), isEditing = _c[0], setIsEditing = _c[1];
    var _d = (0, react_2.useState)(), selectedAddress = _d[0], setSelectedAddress = _d[1];
    var _e = (0, react_2.useState)(""), newAddressName = _e[0], setNewAddressName = _e[1];
    var _f = (0, react_2.useState)(""), addressLabelErrorText = _f[0], setAddressLabelErrorText = _f[1];
    var _g = (0, react_2.useState)(""), deletingId = _g[0], setDeletingId = _g[1];
    var _h = (0, customers_1.useGetCustomerAddressesQuery)(customerId, { skip: !customerId }).data, addressList = _h === void 0 ? [] : _h;
    var _j = (0, customers_1.useAddCustomerAddressMutation)(), addCustomerAddress = _j[0], isSaving = _j[1].isLoading;
    var _k = (0, customers_1.useDeleteCustomerAddressMutation)(), deleteCustomerAddress = _k[0], isDeleting = _k[1].isLoading;
    var showFailure = function (error) {
        var _a;
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [(_a = error === null || error === void 0 ? void 0 : error.error) !== null && _a !== void 0 ? _a : "The request was unsuccessful."] }));
    };
    var validateAddress = function () {
        var messages = [];
        var errorCount = 0;
        setAddressLabelErrorText("");
        if (!selectedAddress) {
            messages.push("Please select an address. When you searched, please click on a prediction to select it.");
        }
        if (!newAddressName) {
            errorCount++;
            setAddressLabelErrorText("Label is required for your new address.");
        }
        if (messages.length > 0 || errorCount > 0) {
            if (messages.length > 0) {
                dispatch((0, main_1.setMessageModal)({ title: "Please select address!", messages: messages }));
            }
            return false;
        }
        else {
            return true;
        }
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!validateAddress())
                        return [2 /*return*/];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, addCustomerAddress({
                            user_id: customerId,
                            address: {
                                label: newAddressName,
                                full_address: (_a = selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.full_address) !== null && _a !== void 0 ? _a : "",
                                latitude: (_b = selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.latitude) !== null && _b !== void 0 ? _b : "",
                                longitude: (_c = selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.longitude) !== null && _c !== void 0 ? _c : "",
                                default: false,
                            },
                        }).unwrap()];
                case 2:
                    _d.sent();
                    setIsEditing(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    showFailure(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (addressId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setDeletingId(addressId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, deleteCustomerAddress({ _id: addressId, user_id: customerId }).unwrap()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    showFailure(error_2);
                    return [3 /*break*/, 5];
                case 4:
                    setDeletingId("");
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row items-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex-1", children: (0, jsx_runtime_1.jsx)(label_1.Label, { label: "Addresses", size: "small", textColor: "text-inputText", bold: true }) }), !isReadOnly && ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "secondary", className: "rounded-full", size: "sm", isPending: isSaving, onPress: function () { return (isEditing ? handleSave() : setIsEditing(true)); }, children: isEditing ? (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:check" }) : (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:plus" }) }), isEditing && ((0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "danger", className: "rounded-full", size: "sm", onPress: function () {
                                    setIsEditing(false);
                                }, children: (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "mdi:close" }) }))] }))] }), isEditing && !isReadOnly ? ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(addressSearch_1.AddressSearch, { letsTradeAPIUrl: process.env.LETS_TRADE_CLIENT_URL, required: true, placeholder: "Search & select address...", size: "sm", onSelectionChange: function (value) {
                            setSelectedAddress({
                                full_address: value.fullAddress,
                                longitude: value.coordinates.lng,
                                latitude: value.coordinates.lat,
                            });
                        } }), (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.full_address) && ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { onChange: function (value) { return setNewAddressName(value); }, isInvalid: !!addressLabelErrorText, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Name" }), (0, jsx_runtime_1.jsx)(react_1.Input, {}), addressLabelErrorText ? (0, jsx_runtime_1.jsx)(react_1.FieldError, { children: addressLabelErrorText }) : null] }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col", children: (0, jsx_runtime_1.jsx)(label_1.Label, { label: selectedAddress.full_address, textColor: "text-black", size: "xsmall" }) })] }))] })) : ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col divide-y divide-border", children: addressList.length > 0 ? (addressList.map(function (address, index) {
                    var _a;
                    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row items-center gap-3 py-2 first:pt-0 last:pb-0", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex min-w-0 flex-1 flex-col gap-0.5", children: [(0, jsx_runtime_1.jsx)(label_1.Label, { label: address.label, bold: true, textColor: "text-inputText", size: "small", className: "leading-5" }), (0, jsx_runtime_1.jsx)(label_1.Label, { label: address.full_address, textColor: "text-muted", size: "xsmall", className: "leading-5" })] }), !isReadOnly && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "danger-soft", size: "sm", isIconOnly: true, "aria-label": "Delete address", isPending: isDeleting && deletingId === address._id, onPress: function () { var _a; return handleDelete((_a = address._id) !== null && _a !== void 0 ? _a : ""); }, children: (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:trash-bin-trash-linear", width: 16 }) }) }))] }, (_a = address._id) !== null && _a !== void 0 ? _a : index));
                })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-muted", children: "No addresses added yet." })) }))] }));
};
exports.AddressComponent = AddressComponent;
